import moment from "moment"

/*今天*/
export function thisToday() {
    return moment(moment().valueOf()).format('YYYY-MM-DD');
}

/*昨天*/
export function thisYesterday() {
    return moment().subtract(1, "days").format("YYYY-MM-DD")
}

/* 本周*/
export function thisWeek() {
    const weekOfDay = moment(thisToday(), 'YYYY-MM-DD').format('E');
    const startWeek = moment().subtract((weekOfDay as any) - 1, 'days').format('YYYY-MM-DD');//周一日期
    const endWeek = moment().add(7 - (weekOfDay as any), 'days').format('YYYY-MM-DD');//周日日期

    return [startWeek, endWeek]
}

/*上周*/
export function lastWeek() {
    const startLastWeek = moment(moment().week(moment().week() - 1).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD'); //周一日期
    const endLastWeek = moment(moment().week(moment().week() - 1).endOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD'); //周日日期

    return [startLastWeek, endLastWeek]
}

/*本月*/
export function thisMonth() {
    const startMonth = moment(moment().month(moment().month()).startOf('month').valueOf()).format('YYYY-MM-DD');
    const endMonth = moment(moment().month(moment().month()).endOf('month').valueOf()).format('YYYY-MM-DD');

    return [startMonth, endMonth]
}

/*上月*/
export function lastMonth() {
    const startLastMonth = moment(moment().month(moment().month() - 1).startOf('month').valueOf()).format('YYYY-MM-DD');
    const endLastMonth = moment(moment().month(moment().month() - 1).endOf('month').valueOf()).format('YYYY-MM-DD');

    return [startLastMonth, endLastMonth]
}

/*本季度*/
export function thisQuarter() {
    const startQuarter = moment(moment().quarter(moment().quarter()).startOf('quarter').valueOf()).format('YYYY-MM-DD');
    const endQuarter = moment(moment().quarter(moment().quarter()).endOf('quarter').valueOf()).format('YYYY-MM-DD');

    return [startQuarter, endQuarter]
}

/*上季度*/
export function lastQuarter() {
    const startLastQuarter = moment(moment().quarter(moment().quarter() - 1).startOf('quarter').valueOf()).format('YYYY-MM-DD');
    const endLastQuarter = moment(moment().quarter(moment().quarter() - 1).endOf('quarter').valueOf()).format('YYYY-MM-DD');

    return [startLastQuarter, endLastQuarter]
}

/*今年*/
export function thisYear() {
    const startYear = moment(moment().year(moment().year()).startOf('year').valueOf()).format('YYYY-MM-DD');
    const endYear = moment(moment().year(moment().year()).endOf('year').valueOf()).format('YYYY-MM-DD');

    return [startYear, endYear]
}

/*去年*/

export function lastYear() {
    const yesteryearStart = moment(moment().year(moment().year() - 1).startOf('year').valueOf()).format('YYYY-MM-DD');
    const yesteryearEnd = moment(moment().year(moment().year() - 1).endOf('year').valueOf()).format('YYYY-MM-DD');

    return [yesteryearStart, yesteryearEnd]
}
